import React, { useEffect } from 'react';
import { lockScroll, unlockScroll } from '../utils/scrollbarUtils';
import reviewNaverIcon from '../assets/icons/review/naver.png';
import reviewImage1 from '../assets/icons/review/image_1.png';
import reviewFingerIcon from '../assets/icons/review/finger.png';

const ReviewGuide = ({ isOpen, onClose }) => {
  useEffect(() => {
    const scaleUI = () => {
      const wrapper = document.querySelector('.review-guide-wrapper');
      if (wrapper) {
        const viewportWidth = window.innerWidth;
        const scale = Math.min(viewportWidth / 360, 1.5);
        wrapper.style.zoom = scale;
      }
    };
    
    if (isOpen) {
      scaleUI();
      window.addEventListener('resize', scaleUI);
      // 스크롤 잠금
      if (!document.body.dataset.scrollY) {
        lockScroll();
      }
    }
    
    return () => {
      window.removeEventListener('resize', scaleUI);
      // 스크롤 잠금 해제
      if (isOpen && document.body.dataset.scrollY) {
        unlockScroll();
      }
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    // 버튼이 원래 크기로 돌아온 후 페이지 닫기
    setTimeout(() => {
      onClose();
    }, 100);
  };

  return (
    <div className="review-guide">
      <div className="review-guide-wrapper">
        <div className="review-guide-content">
          <img 
            src={reviewNaverIcon}
            alt="Naver"
            className="naver-logo"
          />
          
          <div className="main-title">
            음식 기다릴 동안 <br /> 네이버 리뷰 쓰는 법 알려줄게요 :)
          </div>

          <div className="step-container">
            <div className="step-item step-1">
              <span className="step-number">1</span>
              <span className="step-text">리뷰를 쓰고 싶을 때 QR을 다시 한 번 찍어주세요</span>
            </div>
            
            <div className="step-line line-1"></div>
            
            <div className="step-item step-2">
              <span className="step-number">2</span>
              <span className="step-text">자동으로 네이버 리뷰 사이트로 이동돼요</span>
            </div>
            
            <div className="step-line line-2"></div>
            
            <div className="step-item step-3">
              <span className="step-number">3</span>
              <span className="step-text">영수증 버튼 클릭 후, 영수증 스캔하면 끝!</span>
            </div>
          </div>

          <div className="image-container">
            <img 
              src={reviewImage1}
              alt="Review Guide"
              className="guide-image"
            />
            <img 
              src={reviewFingerIcon}
              alt="Finger"
              className="finger-image"
            />
          </div>
        </div>

        <button 
          className="confirm-button"
          onClick={handleConfirm}
          onMouseDown={(e) => {
            e.currentTarget.classList.add('pressed');
          }}
          onMouseUp={(e) => {
            e.currentTarget.classList.remove('pressed');
          }}
          onMouseLeave={(e) => {
            e.currentTarget.classList.remove('pressed');
          }}
          onTouchStart={(e) => {
            e.currentTarget.classList.add('pressed');
          }}
          onTouchEnd={(e) => {
            e.currentTarget.classList.remove('pressed');
          }}
        >
          확인했어요, 메뉴판으로 이동
        </button>
      </div>

      <style jsx="true">{`
        .review-guide {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          z-index: 10001;
          display: flex;
          justify-content: center;
          overflow: hidden;
        }

        .review-guide-wrapper {
          width: 360px;
          background: white;
          position: relative;
          height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .review-guide-content {
          width: 100%;
          padding: 0 23px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          flex: 1;
        }

        .naver-logo {
          margin-top: 36px;
          margin-left: 1px;
          width: 67px;
          height: 13px;
          opacity: 0;
          animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation-delay: 0.4s;
        }

        .main-title {
          margin-top: 12px;
          font-size: 22px;
          font-weight: bold;
          text-align: left;
          line-height: 26px;
          color: #000000;
          opacity: 0;
          animation: fadeIn 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation-delay: 0.4s;
        }

        @keyframes fadeIn {
          to {
            opacity: 1;
          }
        }

        .step-container {
          margin-top: 46px;
          width: 100%;
          display: flex;
          flex-direction: column;
        }

        .step-item {
          display: flex;
          align-items: flex-start;
          width: 100%;
          opacity: 0;
          transform: translateY(-20px);
          animation: fadeInDown 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }

        .step-1 {
          animation-delay: 1.2s;
        }

        .step-2 {
          animation-delay: 2.05s;
        }

        .step-3 {
          animation-delay: 2.85s;
        }

        .step-line {
          width: 2px;
          height: 0;
          max-height: 60px;
          background: rgba(217, 217, 217, 0.5);
          border-radius: 10px;
          margin-left: 3.5px;
          margin-top: 13px;
          margin-bottom: 15px;
          opacity: 0;
          animation: stretchLine 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
        }

        .line-1 {
          animation-delay: 1.55s;
        }

        .line-2 {
          animation-delay: 2.35s;
        }

        @keyframes stretchLine {
          0% {
            opacity: 0;
            height: 42px; /* 70% of 60px */
          }
          30% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            height: 60px;
          }
        }

        @keyframes fadeInDown {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .review-guide .step-number {
          position: static;
          width: auto;
          height: auto;
          background: none;
          border-radius: 0;
          box-shadow: none;
          font-size: 16px;
          font-weight: 600;
          color: #03CF5D;
          margin-right: 10px;
          flex-shrink: 0;
        }

        .review-guide .step-text {
          font-size: 14px;
          font-weight: 600;
          color: #000000;
          line-height: 1.4;
        }

        .image-container {
          position: relative;
          margin-top: 36px;
          align-self: center;
          width: 296px;
          height: 85px;
        }

        .guide-image {
          width: 296px;
          height: 85px;
          opacity: 0;
          transform: translateY(-20px);
          animation: fadeInDown 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation-delay: 2.85s;
        }

        .finger-image {
          position: absolute;
          width: 57px;
          height: 59px;
          bottom: -8px;
          left: 38px;
          opacity: 0;
          transform: translate(17px, 17px);
          animation: fadeInDiagonal 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation-delay: 3.15s;
        }

        .confirm-button {
          position: fixed;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%) translateY(30px);
          width: 330px;
          height: 50px;
          border: 1.2px solid #0CE36B;
          border-radius: 10px;
          background: #F1FEF3;
          font-size: 17px;
          font-weight: bold;
          color: #11C962;
          cursor: pointer;
          transition: transform 0.1s ease;
          box-shadow: 0 0 4px rgba(111, 255, 71, 0.3);
          opacity: 0;
          animation: fadeInUpButton 0.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          animation-delay: 3.75s;
        }

        .confirm-button.pressed {
          transform: translateX(-50%) translateY(0) scale(0.95) !important;
        }

        @keyframes fadeInUpButton {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        @keyframes fadeInUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInDiagonal {
          from {
            opacity: 0;
            transform: translate(17px, 17px);
          }
          to {
            opacity: 1;
            transform: translate(0, 0);
          }
        }

        @media (min-width: 361px) {
          .confirm-button {
            position: fixed;
            bottom: 16px;
            left: 50%;
            transform: translateX(-50%);
            width: 330px;
          }
        }
      `}</style>
    </div>
  );
};

export default ReviewGuide;